import React from 'react';
import styles from './Sections.module.scss';

type Props = {
    title: string;
    detail?: React.ReactNode;
    leftIcon?: React.ReactNode;
    isAdmin?: boolean;
    id?: string;
}

function TitleSection(props: Props) {
    const { id, title, detail, leftIcon } = props

    return (
        <div id={id} className={styles.sectionTitleView}>
            <div className={styles.sectionTitle}>
                {leftIcon}
                <h2>{title}</h2>
            </div>
            <div className={styles.sectionDetail}>
                {detail}
            </div>
        </div>
    )
}

export default TitleSection